import { css } from 'styled-components';

/** Respect OS reduced-motion preference globally via GlobalStyle; use for scoped overrides. */
export const reducedMotionSafe = css`
  @media (prefers-reduced-motion: reduce) {
    transition: none !important;
    animation: none !important;
    transform: none !important;
  }
`;

export const hoverBackgroundTransition = css`
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  ${reducedMotionSafe}
`;

export const hoverLiftCard = css`
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: translateY(-4px);
      box-shadow: ${({ theme }) => theme.shadows?.elevated ?? '0 4px 16px rgba(0, 0, 0, 0.12)'};
    }
  }
  ${reducedMotionSafe}
`;

export const hoverLiftSmall = css`
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: translateY(-2px);
    }
  }
  ${reducedMotionSafe}
`;

export const hoverPrimaryFill = css`
  ${hoverBackgroundTransition}
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => (theme.mode === 'dark' ? theme.colors.textInverse : '#fff')};
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const hoverBorderLift = css`
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  ${reducedMotionSafe}
`;

export const inputFieldTransition = css`
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
  ${reducedMotionSafe}
`;

export const labelFadeTransition = css`
  transition: opacity 0.18s ease, transform 0.18s ease;
  ${reducedMotionSafe}
`;

export const hoverScaleTransition = css`
  transition: transform 0.2s ease, filter 0.2s ease;
  ${reducedMotionSafe}
`;

export const hoverTranslateTransition = css`
  transition: transform 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  ${reducedMotionSafe}
`;

/** Scale thumbnail inside an overflow-hidden frame — card itself does not lift. */
export const thumbScaleHover = css`
  overflow: hidden;

  img {
    transition: transform 0.2s ease;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover img {
      transform: scale(1.03);
    }
  }

  ${reducedMotionSafe}
`;
